// removed by extract-text-webpack-plugin
module.exports = {"material-icons":"index--material-icons--2GJXGz6p","materialIcons":"index--material-icons--2GJXGz6p"};


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 854
// module chunks = 2